<template>
    <header>
        <div id="site-header">
            <div class="logo-block">
                <!-- <div class="sidebar-header">
                    <button @click="toggleSidebar" class="sidebar-toggle">
                        <font-awesome-icon icon="fa-bars" />
                    </button>
                </div> -->
                <a class="logo" href="/">
                    <img class="t-logo" alt="Trimate logo" src="../assets/header-logo.webp">
                    <span class="vortex-text" alt="Vortex logo">Vortex</span>
                    <Vue3Lottie :animationData="blobJSON" :height="35" :width="35" />
                </a>
            </div>
            <!--<nav>
                <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/about">About</router-link></li>
                    <li><router-link to="/contact">Contact Us</router-link></li>
                </ul>
            </nav>-->
            <div class="logout-btn">
                <button @click="logout">LOGOUT</button>
            </div>
        </div>

    </header>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie'
import blobJSON from '../assets/tria_blob_anim.json'
import { signOut } from 'firebase/auth';
import { auth } from '@/firebase'; // adjust path if needed

export default {
    methods: {
        async logout() {
            try {
                await signOut(auth);

                // Clear localStorage or any state
                localStorage.clear();

                // Redirect to login
                this.$router.push('/home');
            } catch (error) {
                console.error('Logout error:', error);
                alert('Something went wrong during logout.');
            }
        },
        toggleSidebar() {
            this.isSidebarOpen = !this.isSidebarOpen;
        },
    },
    components: {
        Vue3Lottie,
    },
    data() {
        return {
            blobJSON,
            isSidebarOpen: true,
        }
    },
}
</script>

<style scoped>
header {
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: .5rem 1rem;
    background-color: black;

    p {
        margin-left: 1rem;
    }

    max-height: 80px;
}

#site-header {
    display: grid;
    width: 100%;
    height: 80px;
    grid-template-columns: auto auto auto;
    box-sizing: content-box;
}

.logo-block {
    grid-column-start: 1;
    grid-column-end: 1;
    align-content: center;
    justify-self: left;
}

.logo img.t-logo,
img.v-text {
    max-height: 30px;
}

.logo img.t-logo {
    margin-right: 10px;
    margin-bottom: -3px;
}

.vortex-text {
    font-family: "Major Mono Display", monospace;
    font-size: 30px;
    font-weight: bold;
    -webkit-text-fill-color: transparent !important;
    -webkit-background-clip: text !important;
    background-clip: text !important;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background: linear-gradient(135deg, #788e90, #FE602F);
    text-decoration: none;
}

.lottie-animation-container {
    display: inline-block;
    margin-bottom: -8px;
    margin-left: 5px;
}

nav {
    margin-left: auto;
    align-content: center;
    grid-column-start: 4;
    grid-column-end: 4;

    ul {
        list-style: none;
    }

    ul li {
        display: inline-flex;
        margin-left: 1rem;
    }

    ul li a {
        text-decoration: none;
        color: white;
    }

    ul li a:hover {
        cursor: pointer;
    }
}

button {
    background-color: #38434e;
    color: white;
    text-decoration: none;
    border-radius: 50px;
    cursor: pointer;
    align-self: center;
    margin: 0 20px;
    max-width: 160px;
    min-width: auto;
}

.logout-btn {
    grid-column-start: 3;
    justify-self: right;
    align-self: center;
}

.btn:hover {
    background-color: #e45f2b;
}

.btn a {
    text-decoration: none;
    color: white;
    font-size: 14px;
    vertical-align: super;
}

a.logo:-webkit-any-link {
    color: black;
}
</style>
